(function () {
  'use strict';

  var config = window.__TURAPURA_COD_GUARD_CONFIG__ || {};
  var countryCode = String(config.countryCode || '').toUpperCase();
  if (!countryCode) return;
  if (window.__TURAPURA_COD_GUARD__) return;
  var observedContactFields = new WeakSet();

  function normalizePhone(value) {
    var raw = String(value || '').trim();
    if (!raw || /[^\d+\s().\-]/.test(raw)) return null;
    var cleaned = raw.replace(/[\s().\-]/g, '');
    if (cleaned.indexOf('00') === 0) cleaned = '+' + cleaned.slice(2);
    if (cleaned.indexOf('+0') === 0 && countryCode === 'BG') cleaned = cleaned.slice(1);
    if (cleaned.charAt(0) !== '+') {
      if (countryCode === 'BG') {
        if (/^359[1-9]\d{6,8}$/.test(cleaned)) cleaned = '+' + cleaned;
        else {
          cleaned = cleaned.replace(/^0/, '');
          if (!/^[1-9]\d{6,8}$/.test(cleaned)) return null;
          cleaned = '+359' + cleaned;
        }
      } else if (countryCode === 'GR') {
        if (/^30[1-9]\d{9}$/.test(cleaned)) cleaned = '+' + cleaned;
        else {
          if (!/^[1-9]\d{9}$/.test(cleaned)) return null;
          cleaned = '+30' + cleaned;
        }
      } else return null;
    }
    if (!/^\+[1-9]\d{7,14}$/.test(cleaned)) return null;
    if (cleaned.indexOf('+359') === 0 && !/^\+359[1-9]\d{6,8}$/.test(cleaned)) return null;
    if (cleaned.indexOf('+30') === 0 && !/^\+30[1-9]\d{9}$/.test(cleaned)) return null;
    return cleaned;
  }

  function getField(form, name) {
    return form ? form.querySelector('[name="' + name + '"]') : null;
  }

  function markInvalid(input, message) {
    if (!input) return;
    input.required = true;
    input.setAttribute('aria-required', 'true');
    input.setCustomValidity(message);
    if (window.COD && typeof window.COD._markFieldInvalid === 'function') {
      window.COD._markFieldInvalid(input, message);
    }
  }

  function clearInvalid(input) {
    if (!input) return;
    input.setCustomValidity('');
  }

  function validateContact(form, focusInvalid) {
    var phone = getField(form, 'phone');
    var email = getField(form, 'email');
    var requiredMessage = config.requiredMessage || 'This field is required.';
    var invalidEmailMessage = config.invalidEmailMessage || 'Enter a valid email address.';
    var firstInvalid = null;

    if (phone) {
      phone.required = true;
      phone.setAttribute('aria-required', 'true');
      if (!String(phone.value || '').trim()) {
        markInvalid(phone, requiredMessage);
        firstInvalid = firstInvalid || phone;
      } else if (!normalizePhone(phone.value)) {
        markInvalid(phone, config.invalidEmailMessage || requiredMessage);
        firstInvalid = firstInvalid || phone;
      } else {
        phone.value = normalizePhone(phone.value);
        clearInvalid(phone);
      }
    }

    if (email) {
      email.required = true;
      email.setAttribute('aria-required', 'true');
      var emailValue = String(email.value || '').trim();
      if (!emailValue) {
        markInvalid(email, requiredMessage);
        firstInvalid = firstInvalid || email;
      } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailValue)) {
        markInvalid(email, invalidEmailMessage);
        firstInvalid = firstInvalid || email;
      } else {
        email.value = emailValue;
        clearInvalid(email);
      }
    }

    if (firstInvalid && focusInvalid) {
      firstInvalid.focus();
      firstInvalid.reportValidity();
    }
    return !firstInvalid;
  }

  function enforceRequiredFields(root) {
    var form = root && root.matches && root.matches('#cod-form') ? root : document.getElementById('cod-form');
    if (!form) return;
    ['phone', 'email'].forEach(function (name) {
      var input = getField(form, name);
      if (!input) return;
      input.required = true;
      input.setAttribute('aria-required', 'true');
      input.setAttribute('autocomplete', name === 'phone' ? 'tel' : 'email');
      input.setAttribute('inputmode', name === 'phone' ? 'tel' : 'email');
      if (name === 'phone') input.setAttribute('type', 'tel');
      if (name === 'email') input.setAttribute('type', 'email');
      if (!observedContactFields.has(input)) {
        input.addEventListener('input', function () { clearInvalid(input); });
        observedContactFields.add(input);
      }
    });
    Object.keys({ firstName: 'given-name', lastName: 'family-name', address: 'address-line1', city: 'address-level2', zip: 'postal-code', province: 'address-level1' }).forEach(function (name) {
      var field = getField(form, name);
      if (field) field.setAttribute('autocomplete', { firstName: 'given-name', lastName: 'family-name', address: 'address-line1', city: 'address-level2', zip: 'postal-code', province: 'address-level1' }[name]);
    });
  }

  function localizeCodRuntime() {
    if (!window.COD || window.COD.__turapuraLocalized || typeof window.COD.getStrings !== 'function') return;
    var originalGetStrings = window.COD.getStrings;
    window.COD.getStrings = function (formConfig) {
      return Object.assign({}, originalGetStrings.call(this, formConfig), config.formStrings || {});
    };
    window.COD.__turapuraLocalized = true;
  }
  document.addEventListener('DOMContentLoaded', localizeCodRuntime);
  if (document.readyState !== 'loading') localizeCodRuntime();

  document.addEventListener('submit', function (event) {
    if (!event.target || event.target.id !== 'cod-form') return;
    if (validateContact(event.target, true)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
  }, true);

  document.addEventListener('click', function (event) {
    var button = event.target.closest('#cod-form button[type="submit"], #cod-form input[type="submit"]');
    if (!button) return;
    var form = button.closest('#cod-form');
    if (validateContact(form, true)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
  }, true);

  document.addEventListener('input', function (event) {
    if (!event.target.matches || !event.target.matches('#cod-form [name="phone"], #cod-form [name="email"]')) return;
    clearInvalid(event.target);
  }, true);

  document.addEventListener('focusout', function (event) {
    if (!event.target.matches || !event.target.matches('#cod-form [name="phone"]')) return;
    var normalized = normalizePhone(event.target.value);
    if (normalized) event.target.value = normalized;
  }, true);

  var formRefreshPending = false;
  function refreshForm() {
    if (formRefreshPending) return;
    formRefreshPending = true;
    (window.requestAnimationFrame || function (callback) { return window.setTimeout(callback, 16); })(function () {
      formRefreshPending = false;
      enforceRequiredFields(document);
      localizeCodRuntime();
    });
  }
  var observer = new MutationObserver(function (records) {
    for (var i = 0; i < records.length; i++) {
      for (var j = 0; j < records[i].addedNodes.length; j++) {
        var node = records[i].addedNodes[j];
        if (node.nodeType !== 1) continue;
        if ((node.matches && node.matches('#cod-form')) || (node.closest && node.closest('#cod-form')) || (node.querySelector && node.querySelector('#cod-form'))) {
          refreshForm();
          return;
        }
      }
    }
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('DOMContentLoaded', function () { enforceRequiredFields(document); });

  var nativeFetch = window.fetch.bind(window);
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : input && input.url ? input.url : '';
    var method = String(init && init.method ? init.method : input && input.method ? input.method : 'GET').toUpperCase();
    var parsedUrl;
    try { parsedUrl = new URL(url, window.location.origin); } catch (error) { return nativeFetch(input, init); }
    var sameOrigin = parsedUrl.origin === window.location.origin;
    if (!sameOrigin) return nativeFetch(input, init);
    if (config.codOnly && method === 'GET' && parsedUrl.pathname === '/apps/cod/config') {
      return nativeFetch(input, init).then(function (response) {
        if (!response.ok) return response;
        return response.clone().json().then(function (formConfig) {
          formConfig.lang = config.language || formConfig.lang;
          formConfig.settings = Object.assign({}, formConfig.settings || {}, {
            country: countryCode,
            enableCardPayment: false,
            cardPaymentEnabled: false,
            autoRedirectOnCodBlocked: false
          });
          if (Array.isArray(formConfig.fields)) {
            formConfig.fields = formConfig.fields.filter(function (field) {
              return field.type !== 'payment_card' && field.type !== 'billing';
            }).map(function (field) {
              var label = (config.fieldLabels || {})[field.id] || (config.fieldLabels || {})[field.type];
              if (!label) return field;
              return Object.assign({}, field, { label: label, placeholder: label });
            });
          }
          var headers = new Headers(response.headers);
          headers.delete('content-length');
          headers.delete('content-encoding');
          return new Response(JSON.stringify(formConfig), { status: response.status, statusText: response.statusText, headers: headers });
        }).catch(function () { return response; });
      });
    }
    if (config.codOnly && method === 'POST' && parsedUrl.pathname === '/apps/cod/card-order') {
      return Promise.reject(new Error('Card checkout is not available in this COD storefront.'));
    }
    var isOrder = parsedUrl.pathname === '/apps/cod/order';
    var isRiskCheck = parsedUrl.pathname === '/apps/cod/risk-check';
    var isCodRequest = method === 'POST' && (isOrder || isRiskCheck);
    if (!isCodRequest || !init || typeof init.body !== 'string') return nativeFetch(input, init);

    try {
      var payload = JSON.parse(init.body);
      var phone = normalizePhone(payload.phone);
      var email = String(payload.email || '').trim();
      if (isOrder && (!phone || !email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email))) {
        validateContact(document.getElementById('cod-form'), true);
        return Promise.reject(new Error(config.requiredMessage || 'Phone and email are required.'));
      }
      if (isRiskCheck && String(payload.phone || '').trim() && !phone) {
        return Promise.reject(new Error(config.invalidEmailMessage || config.requiredMessage || 'Invalid phone number.'));
      }
      if (phone) payload.phone = phone;
      payload.email = email;
      if (isOrder) payload.country = countryCode;
      init = Object.assign({}, init, { body: JSON.stringify(payload) });
    } catch (error) {
      return Promise.reject(error);
    }

    return nativeFetch(input, init);
  };

  window.__TURAPURA_COD_GUARD__ = {
    countryCode: countryCode,
    validate: validateContact,
    normalizePhone: normalizePhone
  };
})();
